<template>
  <block-item-card
    :min-height="minBlockHeight"
    :title="$t('ALM.Section.InvestmentsPortfolio.InvestmentsYields.Title')"
  >
    <div
      class="py-5 px-4 d-flex justify-start flex-column"
      style="height: 315px; width: 100%; gap:20px;"
    >
      <div
        class="d-flex flex-column"
        style="width: 100%; gap: 10px;"
      >
        <div
          class="d-flex justify-space-between align-center"
          style="width: 100%;"
        >
          <p class="pa-0 ma-0">
            {{ $t('ALM.Section.InvestmentsPortfolio.InvestmentsYields.Fields.YieldPercentage') }}
          </p>
          <p class="pa-0 ma-0 text-size-28 font-weight-medium">
            {{ yieldPercentage }}
          </p>
        </div>
        <v-progress-linear
          :value="100"
          color="#6E8EDF"
          height="10"
          rounded
          background-color="white"
        />
      </div>
      <div
        class="d-flex flex-column"
        style="width: 100%; gap: 10px;"
      >
        <div
          class="d-flex justify-space-between align-center"
          style="width: 100%;"
        >
          <p class="pa-0 ma-0">
            {{ $t('ALM.Section.InvestmentsPortfolio.InvestmentsYields.Fields.IncomePA') }}
          </p>
          <p class="pa-0 ma-0 text-size-28 font-weight-medium">
            {{ incomePA }}
          </p>
        </div>
        <v-progress-linear
          :value="100"
          color="#57C05B"
          height="10"
          rounded
          background-color="white"
        />
      </div>
    </div>
  </block-item-card>
</template>

<script>
import BlockItemCard from '@/theme/default/components/common/BlockItemCard'
import chartsColorMixin from '@/theme/default/components/charts/mixins/chartsColorMixin'
import { toNumberFormatNotationShort } from '@/lib/utils/helper'

export default {
  name      : 'InvestmentsYields',
  components: {
    BlockItemCard
  },
  mixins   : [chartsColorMixin],
  props    : {},
  dataStore: {
    Investments: 'ALM.Investments.Data'
  },
  data () {
    return {
      minBlockHeight: 350,
      chartHeight   : 120
    }
  },
  computed: {
    yields () {
      return this.Investments.Yields || {}
    },

    yieldPercentage () {
      return (this.yields.yield || 0) + '%'
    },
    currencySymbol () {
      return this.Investments.BaseCurrencyDisplaySymbol || ''
    },

    incomePA () {
      return this.currencySymbol + this.formatNumberShort(this.yields.income || 0)
    }
  },

  methods: {
    formatNumberShort (value) {
      return toNumberFormatNotationShort(value)
    }

  }
}
</script>

<style scoped>
</style>
